import { EasyNavigationSection } from "./easyNavigation.section";
export default EasyNavigationSection;